var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.42227V11.8348H9.41704V7.69133C9.41704 6.66891 9.04036 5.96936 8.12556 5.96936C7.42601 5.96936 6.99552 6.45366 6.83408 6.88416C6.78027 7.04559 6.72646 7.26084 6.72646 7.5299V11.8348H4.1435C4.1435 11.8348 4.19731 4.83932 4.1435 4.13976H6.72646V5.216C7.04933 4.67788 7.69507 3.92452 9.04036 3.92452C10.7085 3.92452 12 5.05456 12 7.42227ZM1.45291 0.426758C0.591927 0.426758 0 1.01869 0 1.77205C0 2.52541 0.538116 3.11734 1.3991 3.11734C2.3139 3.11734 2.85202 2.52541 2.85202 1.77205C2.90583 0.964875 2.36771 0.426758 1.45291 0.426758ZM0.161435 11.8348H2.74439V4.13976H0.161435V11.8348Z",
    fill: "#2878B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinDark);
export default __webpack_public_path__ + "static/media/linkedin-dark.a542e241990adffc2fce69a52baafd1a.svg";
export { ForwardRef as ReactComponent };